import { Radio as AntdRadio } from 'antd';

const RadioGroup = ({ options = [], value = '', onChange = () => {}, style = {} }) => {
  return <AntdRadio.Group options={options} value={value} onChange={onChange} style={style} />;
};

export default RadioGroup;
